<button
  type="button"
  class="color-picker color-choice color-choice-item"
  [class.disabled]="disabled"
  [ngbPopover]="colorPickerPopTemplate"
  [disablePopover]="disabled"
  popoverClass="color-picker-popover"
  #popRef="ngbPopover"
  [ngClass]="style || defaultStyle"
  placement="bottom"
>
  <i class="fa fa-caret-down color-picker-arrow"></i>
</button>

<ng-template #colorPickerPopTemplate>
  <div *ngFor="let style of colorPickerOptions">
    <button
      class="color-choice color-choice-item {{ style }} item-{{ style }}"
      (click)="setStyle(style)"
    ></button>
  </div>
</ng-template>
